import styled from 'styled-components';
import { BORDER, COMMON, FLEX_CONTAINER, LAYOUT } from '../constants';
const AvatarContainer = styled.div.withConfig({
  displayName: "AvatarContainer",
  componentId: "sc-1fmugnk-0"
})(["", ";", ";", ";", ";overflow:hidden;position:relative;"], COMMON, FLEX_CONTAINER, BORDER, LAYOUT);
AvatarContainer.defaultProps = {
  borderRadius: 2,
  display: 'inline-flex',
  justifyContent: 'center'
};
AvatarContainer.propTypes = { ...COMMON.propTypes,
  ...FLEX_CONTAINER.propTypes,
  ...LAYOUT.propTypes
};
AvatarContainer.displayName = 'AvatarContainer';
export default AvatarContainer;